import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="bg-background-50">
      <div className="flex flex-col lg:flex-row">
        <div className="lg:w-1/2 relative min-h-[350px] md:min-h-[450px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=A%20dark%20atmospheric%20Korean%20manhwa%20reading%20scene%2C%20person%20reading%20webtoon%20on%20tablet%20in%20cozy%20dark%20room%2C%20warm%20ambient%20light%20from%20screen%2C%20immersive%20atmosphere%2C%20Korean%20digital%20illustration%20style%2C%20no%20text%2C%20professional%20art&width=900&height=600&seq=cta-left-image&orientation=landscape"
            alt="随时随地阅读韩漫"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-transparent to-transparent lg:bg-gradient-to-r lg:from-transparent lg:to-background-50/80"></div>
          <div className="absolute top-6 left-6">
            <span className="inline-block px-3 py-1 text-[11px] font-label font-medium text-foreground-400 border border-foreground-50/20 rounded-full whitespace-nowrap">
              随时随地
            </span>
          </div>
          <div className="absolute bottom-8 left-6">
            <h2 className="text-3xl md:text-5xl font-heading font-black text-foreground-50 leading-tight">
              开启你的
              <br />
              韩漫之旅
              <br />
              现在就出发
            </h2>
          </div>
        </div>

        <div className="lg:w-1/2 flex flex-col items-center justify-center px-6 py-14 md:py-20 bg-background-100">
          <div className="max-w-md text-center">
            <h3 className="text-2xl md:text-4xl font-heading font-black text-foreground-50 leading-tight">
              无需注册
              <br />
              马上阅读
            </h3>
            <p className="mt-5 text-sm text-foreground-500 leading-relaxed">
              打开韩漫网即可免费在线阅读海量韩国漫画，无需注册账号，无需下载APP。支持手机、平板、电脑多种设备，让你随时随地畅享漫画阅读的乐趣。
            </p>
            <Link
              to="/category/qihuan"
              className="inline-flex items-center gap-2 mt-8 px-7 py-3.5 rounded-full bg-primary-500 text-background-950 font-semibold text-sm hover:bg-primary-400 transition-colors whitespace-nowrap cursor-pointer"
            >
              免费开始阅读
              <i className="ri-arrow-right-line text-base"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}